export default "__VITE_ASSET__o$lHPom3__"